import React from "react";
import { Link, useLocation } from "react-router-dom";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";
import { Skeleton } from "@/components/ui/skeleton";
import { useAutomationServersQuery } from "@/hooks/useAutomationServersQuery";

const routeNameMap: Record<string, string> = {
  dashboard: "Dashboard",
  "automation-servers": "Automation Servers",
  settings: "Settings",
  billing: "Billing",
  contracts: "Contracts",
  account: "Account",
};

function ServerName({ id }: { id: string }) {
  const { data, isLoading } = useAutomationServersQuery();
  const server = data?.pages.flatMap((page) => page.results).find((s) => s.automation_server_id === id);
  if (isLoading && !server) return <Skeleton className="inline-block h-4 w-24 align-middle" />;
  return <>{server?.name ?? id}</>;
}

export function PageBreadcrumbs() {
  const { pathname } = useLocation();
  const segments = pathname.split("/").filter(Boolean);

  const crumbs = segments.map((segment, index) => {
    const href = "/" + segments.slice(0, index + 1).join("/");
    const isServerId = index > 0 && segments[index - 1] === "automation-servers";
    const name = isServerId ? <ServerName id={segment} /> : routeNameMap[segment] ?? segment;
    return { href, name, isLast: index === segments.length - 1 };
  });

  return (
    <Breadcrumb>
      <BreadcrumbList>
        {crumbs.map((crumb, index) => (
          <React.Fragment key={crumb.href}>
            {index > 0 && <BreadcrumbSeparator />}
            <BreadcrumbItem>
              {crumb.isLast ? (
                <BreadcrumbPage>{crumb.name}</BreadcrumbPage>
              ) : (
                <BreadcrumbLink asChild>
                  <Link to={crumb.href}>{crumb.name}</Link>
                </BreadcrumbLink>
              )}
            </BreadcrumbItem>
          </React.Fragment>
        ))}
      </BreadcrumbList>
    </Breadcrumb>
  );
}
